import { useEffect, useLayoutEffect } from "react";
import { routes } from "@/routes";
import { notify, registerContext } from "./notify";
import { resolveRoutePattern } from "./routePattern";

export function usePageViewTracking(pathname: string): void {
  useLayoutEffect(() => {
    const routePattern = resolveRoutePattern(pathname);
    if (routePattern === routes.home) {
      return;
    }
    registerContext({ routePattern });
  }, [pathname]);

  useEffect(() => {
    const routePattern = resolveRoutePattern(pathname);
    if (routePattern === routes.home) {
      return;
    }
    notify("nav.page.viewed", { routePattern });
  }, [pathname]);
}
